// Color roles for the commercial dashboard, taken from the validated
// reference palette (dataviz skill) rather than MUI's stock/unvalidated
// defaults - this app has no custom MUI theme, so these are the only
// colorblind-safe, contrast-checked values in play here.
//
// Light mode only: the rest of the app has no dark-mode support at all
// (no ThemeProvider, no prefers-color-scheme handling), so adding a dark
// variant just for this page would be inconsistent rather than complete.

// Status palette (fixed, never themed) - one hue per funnel/lead outcome,
// always paired with an icon/label per the skill's rule (a status color
// never carries meaning alone).
export const STATUS_COLORS = {
  PROSPECT: '#898781', // muted gray - spec's "gris"
  CONTACTED: '#898781',
  DEMO: '#898781',
  TRIAL: '#2a78d6', // categorical slot 1 / sequential default hue - spec's "bleu"
  ACTIVATED: '#2a78d6',
  PAID: '#0ca30c', // status: good - spec's "vert"
  CANCELLATION_SCHEDULED: '#fab219', // status: warning - spec's "orange"
  CHURNED: '#d03b3b', // status: critical - spec's "rouge"
  LOST: '#898781',
};

export const STATUS_LABELS = {
  PROSPECT: 'Prospect',
  CONTACTED: 'Contacté',
  DEMO: 'Démo',
  TRIAL: 'Essai',
  ACTIVATED: 'Activé',
  PAID: 'Payant',
  CANCELLATION_SCHEDULED: 'Résiliation programmée',
  CHURNED: 'Résilié',
  LOST: 'Perdu',
};

export function statusColor(status) {
  return STATUS_COLORS[status] || STATUS_COLORS.PROSPECT;
}

export function statusLabel(status) {
  return STATUS_LABELS[status] || status;
}

// Categorical slots 1-3 (blue/orange/aqua) - validated all-pairs safe in
// both CVD and normal vision, which matters here since the 3 pilot zones
// (Paris 12, Beaune, Guadeloupe) are compared side by side.
export const CATEGORICAL = ['#2a78d6', '#eb6834', '#1baf7a'];

// Ordinal blue ramp for the funnel (ordered stages, not distinct
// categories) - lightest at the widest/earliest stage, darkest at the
// narrowest/most-qualified one. Per the palette's own ordinal rule, the
// lightest step used must still clear 2:1 contrast (step 250 minimum).
export const FUNNEL_RAMP = ['#86b6ef', '#5598e7', '#2a78d6', '#1c5cab', '#0d366b'];

export const INK = {
  primary: '#0b0b0b',
  secondary: '#52514e',
  muted: '#898781',
  success: '#006300',
  gridline: '#e1e0d9',
};
